import firebase from '@/plugins/firebase';

export interface User {
	uid: string;
	displayName: string;
	profile: string;
	photoURL: string;
	providerData: any;
	metadata: any;
	level: number;
	exp: number;
	likeCount: number;
	charCount: number;
	stoneCount: number;
	createdAt: firebase.firestore.FieldValue;
	website: string;
}

export interface Collection {
	id?: string;
	projectId?: string;
	title: string;
	description: string;
	entryCount: 0;
}

export interface Entry {
	id?: string;
	projectId: string;
	collectionId: string;
	label: string;
	size: number;
	license: string;
	logo: string;
	canvases: any[];
	manifestUrl: string;
	metadata: any;
	progress: number;
	thumbnail: string | any;
	r18: boolean;
	related: string;
}

export interface Project {
	id: string;
	createdAt: number;
	title: string;
	description: string;
	likes: { [uid: string]: boolean; };
	owner?: string;
	members: string[];
	markdown: string;
}

export interface TimelineEvent {
	uid: string;
	createdAt: number;
	msg: string;
	likes: { [uid: string]: boolean; };
	eventType: 'transcription' | 'message';
}

export type editingStatus = 'default' | 'initiated' | 'completed' | 'frozen' | 'editing';
export interface ITranscription {
	id?: string;
	editedBy: string | null;
	tempEditedBy: string | null;
	entryId: string;
	index: number;
	prevStatus: editingStatus;
	status: editingStatus;
	text: string;
	tempText: string;
	tempTextChanged: boolean;
	timestamp: firebase.firestore.FieldValue;
	annotations: Array<IRect>;
	tempAnnotations: Array<IRect>;
	share: boolean;
	requestReview: boolean;
	syncMode: boolean;
}

export interface IRect {
	id?: string;
	x: number;
	y: number;
	width: number;
	height: number;
	rotation: number;
	url: string;
	text?: string;
	uid?: string;
	transcriptionId: string;
}

export interface IRectData {
	id?: string;
	rect: IRect;
	text?: string;
	entryId: string;
	index: number;
	transcriptionId: string;
	uid: string;
	isTemp: boolean;
	timestamp?: firebase.firestore.FieldValue;
}

export interface IAnnotation extends IRectData {
	text: string;
}

export enum IDictEntryType {
	kana,
	kanji,
	word,
	other
}
export interface IDictEntry extends IRectData {
	text: string;
	type: IDictEntryType;
	share: boolean;
	comment?: string;
	timestamp?: firebase.firestore.FieldValue;
}

export interface ITag {
	id?: string;
	text: string;
	count: number;
}
export interface ITaggedRect extends IRectData {
	msg?: string;
	uid: string;
	text: string;
	tagIds: { [tagId: string]: boolean; };
	comment: string;
	share: boolean;
}

export type Likers = { [uid: string]: boolean; };
export interface ITranscriptionHistory {
	id?: string;
	entryId: string;
	transcriptionId: string;
	index: number;
	uid: string;
	status: 'default' | 'initiated' | 'completed' | 'frozen' | 'editing';
	text: string;
	timestamp: firebase.firestore.FieldValue;
	requestReview: boolean;
	share: boolean;
	comment: string;
	count: number;
	likers: Likers;
}
export interface ITimelineEvent {
	id: string;
	uid: string;
	type: 'transcription' | 'announce';
	data: any;
	timestamp: firebase.firestore.FieldValue;
	likes: { [uid: string]: boolean; };
	historyId?: string;
}

export interface INotification {
	id: string;
	uid: string;
	state: 'unchecked' | 'unread' | 'read';
	avatarUrl: string;
	type: 'transcription' | 'like' | 'announce' | 'levelup';
	data: any;
	target?: 'transcription' | 'post' | 'comment';
	timestamp: firebase.firestore.FieldValue;
	refPath: string;
}

export interface PersonalHistory {
	id?: string;
	uid: string;
	entryId: string;
	editing: boolean;
	label: string;
	index: number;
	transcriptionId: string;
	timestamp: firebase.firestore.FieldValue;
}
